import styled, { css } from 'styled-components';
import { ApIcon, colors } from '@alixpartners/ui-components';
import React from 'react';

interface IChartWrapper {
  height?: number;
}

export const HeaderLabelContainer = styled.div<{
  align?: 'left' | 'right';
  isRight?: boolean;
}>`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  justify-content: ${(props) =>
    props.align === 'left' ? 'flex-start' : 'flex-end'};
  ${({ isRight }) =>
    isRight &&
    css`
      position: relative;
      right: -12px;
    `};
`;

export const BreakdownByHeaderLabelContainer = styled(HeaderLabelContainer)`
  ${({ isRight }) =>
    isRight &&
    css`
      position: relative;
      right: -7px;
    `};
`;

export const JobRolesHeaderLabelContainer = styled(HeaderLabelContainer)`
  ${({ isRight }) =>
    isRight &&
    css`
      position: relative;
      right: -32px;
    `};
`;

export const HeaderLabelText = styled.div<{ isSmallerFontSize?: boolean }>`
  font-size: 11px;
  justify-content: center;
  display: flex;
`;

export const YearCellIcon = styled.div`
  width: 8px;
  height: 8px;
  min-width: 8px;
  margin-right: 8px;
  background-color: ${(props) => props.color};
  border-radius: 100%;
`;

// Used in stories and can be reused later integrating in real app
export const CollapsibleHeader = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 19px;
  color: ${colors.grey7};
  width: calc(100% - 32px);
`;

export const CollapsibleTableContainer = styled.div`
  width: 714px;
  margin-bottom: 16px;
`;

export const Pagination = styled.div`
  font-size: 13px;
  color: ${colors.grey5};
  margin-left: 6px;
`;

export const ChangeCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 24px;
`;

export const ChangeValue = styled.span<{ isSmallerFontSize?: boolean }>`
  font-size: ${(props) => (props.isSmallerFontSize ? '11' : '13')}px;
`;

export const TrendIcon = styled(ApIcon)<{ isNegative?: boolean }>`
  margin-left: -12px;
`;

export const TableEmptyValue = styled(ChangeValue)`
  margin-right: 12px;
`;

export const Cell = styled((props) => (
  <div
    {...props}
    className="ag-cell ag-cell-not-inline-editing ag-cell-with-height ag-cell-no-focus ag-cell-value"
    title={props.children}
  />
))``;

export const TableWrapper = styled.div<IChartWrapper>`
  font-family: Roboto;
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  width: 100%;
  overflow: hidden;
  &.ag-theme-balham {
    font-family: Roboto;
    .ag-root,
    .ag-root-wrapper,
    .ag-side-bar,
    .ag-status-bar {
      border-width: 0px;
    }
    .ag-header-row {
      border-bottom: 0px;
    }

    .ag-header-group-cell-with-group {
      &:not(:first-child) {
        border-bottom: 1px solid #cccccc;
      }
      .ag-react-container {
        width: 95%;
        .top-table-header-label {
          color: #737373;
          width: 100%;
          display: flex;
          justify-content: center;
          &::after {
            display: none;
          }
        }
      }
    }

    .top-table-header-label {
      font-size: 11px;
    }
    .ag-root {
      .ag-header {
        background-color: transparent;
        border-bottom: 0px;
      }

      .ag-header-row {
        .ag-header-group-cell {
          margin-left: 12px;
          margin-right: 12px;
        }
        .ag-header-cell {
          &:first-child {
            justify-content: flex-start;
            padding-left: 5px;
          }
        }
      }
      .ag-header-cell::after,
      .ag-header-group-cell::after {
        display: none;
      }
      .ag-header-cell {
        font-weight: normal;
        padding-left: 8px;
        padding-right: 8px;
      }
      .ag-row-pinned {
        border-width: 0px;
        .ag-cell {
          font-weight: bold;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          &:first-child {
            justify-content: flex-start;
            font-size: 13px;
            color: #333333;
          }
        }
      }
      .ag-row {
        .ag-cell {
          text-align: left;
          padding-left: 8px;
          padding-right: 8px;
          font-size: 13px;
          &:first-child {
            text-align: left;
            padding-left: 5px;
            font-size: 13px;
            color: #333333;
          }
        }
      }
      .ag-header-row-column {
        border-bottom: 1px solid #cccccc;
      }
      .ag-header-row-column:not(:first-child) .ag-header-cell,
      .ag-header-row-column:not(:first-child)
        .ag-header-group-cell.ag-header-group-cell-with-group {
        border-top: 0px;
        padding-left: 8px;
        padding-right: 8px;
        &:first-child {
          padding-left: 5px;
        }
      }
    }
  }
`;
